import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortName',
  standalone: false,
})
export class ShortNamePipe implements PipeTransform {
  transform(nombreCompleto: string): string {
    const nombres = nombreCompleto.split(' ');
    let shortName = '';

    if (nombres.length > 0) {
      shortName += nombres[0].charAt(0).toUpperCase() + nombres[0].slice(1) + ' ';

      if (nombres.length > 1) {
        shortName += nombres[nombres.length - 1].charAt(0).toUpperCase();
      }
    }

    return shortName;
  }
}
